// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  IncidentStatus,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  incidentId: __t.u64().name("incident_id"),
  at: __t.timestamp(),
  get status() {
    return IncidentStatus;
  },
  message: __t.string(),
  author: __t.string(),
});
